import { FC } from 'react';
import CardBodyCss from '#srcCssModules/card/card-body.module.scss';
import { useBaseContext } from '#base/hooks/use-base-context';
import { CardLocationCityChooserHolder } from '#home/components/card-location';

const CardLocationBody: FC = () => {
  const { hasCityList } = useBaseContext();

  if (!hasCityList) {
    return null;
  }

  return (
    <div className={CardBodyCss.cardBody}>
      <CardLocationCityChooserHolder />
    </div>
  );
};

export { CardLocationBody };
